<template>
  <div class="container-fluid">
    <div class="row bg-gray justify-content-center" style="padding-top:40px;">
      <div class="col-lg-5 col-12 offset-lg-1 text-left px-3">
        <h3>
          What are your allergies?
        </h3>
        <p>
          At-home test measures your IgE antibodies for 40 most common
          environmental allergens and 28 foods. Our doctors review your test
          results and your medical history to recommend the most appropriate
          treatment options.
        </p>
        <div class="text-center">
          <b-img-lazy
            class="d-inline d-lg-none img-fluid"
            src="../assets/img/test-box.png"
            style="width:130%; margin-left: -15%;"
            alt=""
          />
        </div>

        <p class="smaller dark-green">
          <b>Measures:</b>
          Immunoglobulin E (IgE) IgE to 40 inhalant allergens + 28 food
          allergens
        </p>
        <p class="smaller dark-green">
          <b>Collection Method:</b>
          Finger Prick Blood
        </p>
      </div>
      <div class="col-12 d-none d-lg-inline col-lg-6 text-center hero">
        <b-img-lazy
          src="../assets/img/test-box.png"
          style="max-width: 550px; width:150%; margin-left: -25%;"
          alt=""
        />
      </div>
    </div>
    <div class="row bg-gray justify-content-center" style="padding: 40px 0;">
      <div class="col-12 col-md-5 space-top-1">
        <div style="font-size:26px; line-height:52px;">
          <b>Allergy Test:</b>
          <span
            style="color: #477974; text-decoration:line-through; font-size:24px;"
          >
            <span style="color: rgba(0, 0, 0, 0.7);">$249</span>
          </span>
          <b>$149</b>
          <span style="font-size: 12px; line-height: 1; display: block;">
            (after discounts applied at checkout)
          </span>
        </div>
      </div>
      <div class="col-12 col-md-1 space-top-1"></div>
      <div class="col-12 col-md-3 space-top-1">
        <b-btn block variant="primary" href="https://getcurex.com/promo">
          Add to Cart
        </b-btn>
      </div>
    </div>

    <div class="row justify-content-center space-top-2">
      <div class="col-12 col-lg-8 text-center px-3">
        <h4 class="dark-green">We Diagnose the Following Allergies:</h4>
      </div>
      <div class="col-12 col-lg-8 text-center">
        <div class="row justify-content-center space-top-1">
          <div
            class="col-6 col-md-2"
            v-for="allergy in allergies_diagnosed"
            :key="allergy.text"
          >
            <a :href="allergy.url">
              <div
                class="allergy-box"
                :style="{
                  backgroundImage:
                    'url(' +
                    require('../assets/svg/' + allergy.icon + '.svg') +
                    ')'
                }"
              ></div>
              <p class="allergy-box-text">
                <a
                  :href="allergy.url"
                  style="text-decoration:underline;"
                  v-if="allergy.url"
                >
                  {{ allergy.text }}
                </a>
                <span v-if="!allergy.url">{{ allergy.text }}</span>
              </p>
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8 text-center px-3">
        <h4 class="dark-green">
          What's measured:
          <br />
          Total and Allergy-Specific IgE
        </h4>
      </div>
      <div class="col-12 col-lg-8 text-center px-3 space-top-1">
        <b-img-lazy
          src="../assets/svg/spectrum.svg"
          style="width:100%; max-width:700px;"
          alt=""
        />
      </div>
      <div class="col-12 col-lg-8 text-left px-3 space-top-1 space-bottom-2">
        <b>Immunoglobulin E</b>
        (IgE) is a class of antibody specific to allergic reactions. Our test
        measures the amount of allergen-specific IgE in your blood in order to
        detect your allergy propensity to a particular substance. While allergy
        clinicians frequently prefer skin prick tests administered in the
        office, IgE tests are considered more precise in that they can specify
        the exact level of likely allergy for a person. IgE tests account for
        the majority of allergy tests in Western Europe.
      </div>
    </div>

    <a id="how-it-works" />
    <div class="row justify-content-center space-top-2 bg-dark-green">
      <div class="col-12 col-lg-8 text-center px-3">
        <h3 class="white">How it Works</h3>
      </div>
    </div>
    <div
      class="row justify-content-center space-top-1 text-left px-3 bg-dark-green"
    >
      <div class="col-xl-3 col-lg-4 col-md-12 space-top-1">
        <div>
          <h3 class="neon-green">1.</h3>
          <p class="mb-md-0 white">
            Once you order, the test kit is delivered to your home.
          </p>
        </div>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-12 space-top-1">
        <div>
          <h3 class="neon-green">2.</h3>
          <p class="mb-md-0 white">
            Complete a simple finger prick collection and return with prepaid
            shipping.
          </p>
        </div>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-12 space-top-1">
        <div>
          <h3 class="neon-green">3.</h3>
          <p class="mb-md-0 white">
            Our doctor will contact you by text or email to share your test
            results, understand your medical history and help you reduce your
            future allergies.
          </p>
        </div>
      </div>
    </div>
    <div class="row bg-dark-green space-top-2 space-bottom-1">
      <!-- this is for the line in the design -->
      <div class="col-10 border-neon-green ml-auto mr-auto"></div>
    </div>

    <div class="row bg-dark-green text-center text-lg-left space-bottom-1">
      <div class="col-12 text-center">
        <h4 class="white" style="font-size:36px;">What's Included</h4>
      </div>
      <div class="col-12 px-3">
        <!-- TODO: try switching to background image instead -->
        <b-img-lazy
          src="../assets/img/whats-inside.png"
          style="width:100%; height:100%;"
          alt=""
        />
      </div>
    </div>

    <a id="reviews" />
    <div class="row bg-neon-green space-top-2">
      <div class="col text-center  px-3">
        <h3 class="white space-bottom-1">What our users say</h3>
        <b-img-lazy src="../assets/img/stars.png" alt="" />
        <p class="white" style="font-size: 26px; margin-top: 10px;">
          4.4 out of 5 stars, 845 reviews
        </p>
        <b-img-lazy
          src="../assets/img/review-bars.png"
          style="max-width: 799px; width:100%;"
          alt=""
        />
      </div>
    </div>
    <div class="bg-neon-green row">
      <div class="container">
        <div class="row justify-content-center px-3">
          <div class="col-md-4 col-12 space-top-1 space-bottom-2">
            <div>
              <b-img-lazy src="../assets/img/quotation-mark.png" alt="" />

              <p class="darker-text space-top-1">
                Curex helped us understand that my daughter is allergic to cats
                and some pollens. We spoke with Dr Amina and developed an
                allergy plan. We learned why she had allergies and how to fight
                them.
              </p>

              <div class="row">
                <div class="col-3">
                  <b-img-lazy src="../assets/img/liz.png" alt="" />
                </div>
                <div class="col-8 ml-md-3 align-middle text-left">
                  <p class="white font-13" style="margin: 5px 0;">
                    <b class="caps">Liz</b>
                    <br />
                    New Jersey
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-12 space-top-1 space-bottom-2">
            <div>
              <b-img-lazy src="../assets/img/quotation-mark.png" alt="" />

              <p class="darker-text space-top-1">
                It’s so much easier than the allergy test I got at the doctor’s
                office. They screened me for more than 60 allergies and I didn’t
                even have to go anywhere! Just an easy finger prick, four drops
                of blood and I was done.
              </p>

              <div class="row">
                <div class="col-3">
                  <b-img-lazy src="../assets/img/john.png" alt="" />
                </div>
                <div class="col-8 ml-md-3 align-middle text-left">
                  <p class="white font-13" style="margin: 5px 0;">
                    <b class="caps">John</b>
                    <br />
                    California
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-12 space-top-1 space-bottom-2">
            <div>
              <b-img-lazy src="../assets/img/quotation-mark.png" alt="" />

              <p class="darker-text space-top-1">
                Super easy to use. During a doctor video visit, I got a lesson
                in allergies 101. Then I realized I was eligible for allergy
                drops and I started using them. So much better than shots that I
                took as a kid! Feeling better already.
              </p>

              <div class="row">
                <div class="col-3">
                  <div
                    style="background-color: #ffffff;border-radius:33px; width:66px;"
                  >
                    <b-img-lazy
                      src="../assets/img/richard.png"
                      style="margin: 3px; border-radius:30px; width:60px;"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-8 ml-md-3 align-middle text-left">
                  <p class="white font-13" style="margin: 5px 0;">
                    <b class="caps">Richard</b>
                    <br />
                    Virginia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a id="about-us" />
    <div class="row justify-content-center px-3">
      <div class="col-md-5 space-top-2 col-12">
        <h3 class="dark-green">About Us</h3>

        <p class="">
          <b>
            The Curex team has over 50 years of allergy diagnostics and
            treatment experience.
          </b>
          We are the leaders in at-home allergy testing and allergy treatment in
          the U.S. Hundreds of physicians and over 20,000 patients rely on us
          for allergy solutions.
        </p>

        <p class="text-center">
          <b-img-lazy
            src="../assets/img/about-collage.png"
            class="d-inline d-md-none w-100 p-3"
            style="max-width:379px;"
            alt=""
          />
        </p>

        <p class="">
          We provide the most scientifically
          <b>
            rigorous allergy diagnostics services with the convenience of
            at-home testing.
          </b>
          Our test results quantify IgE levels for most common allergens,
          enabling you and your doctor determine the best way to manage your
          allergies.
        </p>
        <p class="">
          During the doctor consultation, after the allergy test is completed,
          you will learn which medications are right for you to better
          <b>
            control your symptoms;
          </b>
          which allergens to
          <b>avoid;</b>
          and whether a course of immunotherapy is right for you to get
          <b>
            long-term relief from your allergies.
          </b>
        </p>
      </div>
      <div
        class="col-12 col-md-4 space-top-2 space-bottom-2 d-none d-md-inline"
      >
        <b-img-lazy
          src="../assets/img/about-collage.png"
          style=" margin-top: 150px;"
          alt=""
        />
      </div>
    </div>

    <a id="faq" />

    <div class="row">
      <div class="col-12 col-md-6 ml-auto mr-auto text-center">
        <b-img-lazy
          class=""
          src="../assets/img/test-box.png"
          style="width: 100%; max-width: 738px;"
          alt=""
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <FAQ />
      </div>
    </div>
    <div class="row">
      <div class="col space-bottom-2 text-center">
        <b-btn
          variant="primary"
          href="https://getcurex.com/promo"
          class="px-7 d-block d-md-inline-block"
        >
          Learn More
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import allergies from "./allergies.json";
import FAQ from "./FAQ.vue";

export default {
  name: "HomePage",
  components: {
    FAQ
  },
  mounted() {
    this.$gtag.event("LabHome");
  },
  data() {
    return {
      allergies_diagnosed: allergies.allergies_diagnosed,
      quantity: 1
    };
  }
};
</script>

<style>
h3 {
  font-weight: bold;
  font-size: 48px;
  line-height: 48px;

  color: #497c77;
}

h5 {
  color: #477974;
  font-weight: bold;
  font-size: 26px;
}

.btn {
  background: #2c534f;
  font-weight: 500;
  font-size: 18px;
}

.btn-bg-white {
  background-color: #ffffff;
  color: #2c534f;
  font-weight: 500;
  font-size: 18px;
}

.bg-gray {
  background: #f1f4f5;
}

.bg-neon-green {
  background: #67df94;
}

.neon-green {
  color: #05e19c;
}

.bg-dark-green {
  background: #497c77;
}

.dark-green {
  color: #497c77;
}

.white {
  color: white;
}

.darker-text {
  color: rgba(0, 0, 0, 0.7);
}

p {
  font-size: 20px;
  line-height: 28px;
}

p.smaller {
  font-size: 16px;
}

@media (min-width: 1005px) {
  .hero {
    text-align: right !important;
  }
}

.font-13 {
  font-size: 13px;
}

.caps {
  text-transform: uppercase;
}

.border-neon-green {
  border: 1px solid #05e19c;
}

.bold {
  font-weight: bold;
}

.quantity-changer {
  height: 52px;

  background-color: #ffffff;
  border: 1px solid #c1c3c4;
  border-radius: 0;
  font-size: 20px;
  color: #477974;
}

input.quantity-changer {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.7);
}

.allergy-box {
  background-color: #f1f4f5;
  border-radius: 6px;
  min-width: 100px;
  min-height: 100px;

  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: auto;
}

.allergy-box-text {
  font-size: 15px;
  line-height: 28px;
}
</style>
